import { range } from "@punks/core"
import React from "react"
import CustomSkeleton from "../../../../ui/atoms/Skeleton"
import Square from "../../../../ui/shapes/Square"
import { CustomBox } from "../../../../ui/spacings"

const WishlistItemSkeleton = () => {
  return (
    <CustomBox flex="row">
      <CustomBox flexBasis="18%">
        <Square>
          <CustomSkeleton variant="circle" width="100%" height="100%" />
        </Square>
      </CustomBox>
      <CustomBox flexFill ml={2}>
        <CustomSkeleton />
        <CustomSkeleton />
        <CustomSkeleton />
      </CustomBox>
    </CustomBox>
  )
}

const WishlistSkeleton = () => {
  return (
    <>
      {range(0, 2).map((x) => (
        <CustomBox my={2} key={x}>
          <WishlistItemSkeleton />
        </CustomBox>
      ))}
    </>
  )
}

export default WishlistSkeleton
